import { EmergencyPage } from '@/modules/guard';

export const Emergency = () => {
  return <EmergencyPage />;
};
